// Analytics Manager for tracking user behavior
export class AnalyticsManager {
  static initialize() {
    this.events = [];
    this.sessionStart = Date.now();
    this.sessionId = this._generateSessionId();
    
    console.log('AnalyticsManager initialized');
    
    // Track page load
    this.trackEvent('page_load', {
      url: window.location.href,
      referrer: document.referrer,
      timestamp: new Date().toISOString()
    });
  }

  static _generateSessionId() {
    return 'session_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
  }

  static trackEvent(eventName, properties = {}) {
    const event = {
      event: eventName,
      properties: {
        ...properties,
        sessionId: this.sessionId,
        timestamp: new Date().toISOString(),
        url: window.location.href,
        userAgent: navigator.userAgent
      }
    };

    // Store locally
    this.events.push(event);

    // Console log in development
    const isDev = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development';
    if (isDev) {
      console.log('Analytics Event:', event);
    }

    // Send to analytics service in production (or when not in dev)
    const isProd = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production';
    if (isProd || !isDev) {
      this._sendToAnalytics(event);
    }
  }

  static _sendToAnalytics(event) {
    // Google Analytics 4
    if (window.gtag) {
      window.gtag('event', event.event, event.properties);
    }

    // Custom analytics endpoint – only when a backend is configured (avoids 404 when no server)
    const customApiEnabled = typeof window !== 'undefined' && (window.__ANALYTICS_API_ENABLED__ === true);
    if (customApiEnabled && navigator.sendBeacon) {
      navigator.sendBeacon('/api/analytics', JSON.stringify(event));
    }
  }

  static trackPageView(pageName, properties = {}) {
    this.trackEvent('page_view', {
      page_name: pageName,
      ...properties
    });
  }

  static trackCalculatorUsage(calculatorType, action, properties = {}) {
    this.trackEvent('calculator_usage', {
      calculator_type: calculatorType,
      action: action,
      ...properties
    });
  }

  static trackError(error, context = '') {
    this.trackEvent('error', {
      error_message: error.message || 'Unknown error',
      error_stack: error.stack || '',
      context: context,
      severity: 'error'
    });
  }

  static trackUserAction(action, properties = {}) {
    this.trackEvent('user_action', {
      action: action,
      ...properties
    });
  }

  static trackPerformance(metric, value, properties = {}) {
    this.trackEvent('performance', {
      metric: metric,
      value: value,
      ...properties
    });
  }

  static getEvents(filter = null, limit = 100) {
    let filteredEvents = this.events;
    
    if (filter) {
      filteredEvents = this.events.filter(event => 
        Object.keys(filter).every(key => event.properties[key] === filter[key])
      );
    }
    
    return filteredEvents.slice(-limit);
  }

  static exportData() {
    return {
      sessionId: this.sessionId,
      sessionStart: this.sessionStart,
      events: this.events
    };
  }
}